export default class UploadBankStatementsRequest {
    public companyId: number | null = null;

    public businessTaxReturnMetaId: number | null = null;

    public year: string | null = null;

    public period: string | null = null;
}